import { IFilter } from "@/models/tables";
import { FilterTypes, FilterOperators } from "@/data/table";
import i18n from "@/i18n";
import { PurchaseTypes } from "@/data/enums/products";
import store from "@/store";
import { DataModules } from "@/store/modules/data";

export const NameFilter = () => ({
  key: "name",
  label: i18n.t("_.product_name"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const ProductCategoryFilter: () => IFilter = () => {
  const getOptions = async () => {
    const categories = await store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/list`,
      {
        storeData: false,
        params: {
          order: "order",
          limit: 0,
          "filter[level]": 1,
          brandId: store.getters["brand/id"]
        }
      }
    );

    return categories?.map(category => ({
      id: category.id,
      label: category.name
    }));
  };

  const filter: IFilter = {
    key: "category_id",
    label: i18n.t("_.product_category"),
    type: FilterTypes.SELECT_MULTI,
    value: [],
    operator: FilterOperators.EQUAL,
    optionsFunc: getOptions,
    if: () => store.getters.isAdminContext
  };

  return filter;
};

export const AvailableForSaleFilter = () => ({
  key: "available_for_sales",
  label: i18n.t("_.active"),
  type: FilterTypes.SELECT_RADIO,
  operator: FilterOperators.EQUAL,
  value: "1"
});

export const ClientCanOrderFilter = () => ({
  key: "clients_can_order",
  label: i18n.t("_.visible_for_clients"),
  type: FilterTypes.SELECT_RADIO,
  operator: FilterOperators.EQUAL,
  value: "1"
});

export const BillinTermFilter = () => ({
  key: "billing_cycle_months",
  label: i18n.t("_.purchase_type"),
  type: FilterTypes.SELECT_CHECKBOX,
  operator: FilterOperators.EQUAL,
  options: [
    {
      value: PurchaseTypes.ONE_OFF,
      label: i18n.t("_.one_off_payment")
    },
    {
      value: PurchaseTypes.RECURRING,
      label: i18n.t("_.recurring_payment")
    }
  ]
});

export const CreatedAtFilter = () => ({
  key: "created_at",
  label: i18n.t("_.created"),
  type: FilterTypes.DATE,
  operator: FilterOperators.AFTER
});

export const CatalogueProductFilters: () => IFilter[] = () => {
  return [
    NameFilter(),
    ProductCategoryFilter(),
    AvailableForSaleFilter(),
    ClientCanOrderFilter(),
    BillinTermFilter(),
    CreatedAtFilter()
  ];
};
